// Standalone tour stub without external driver.js dependency
export const startFlowTour = (isDark = false) => {
  console.log('Flow tour is currently disabled (driver.js removed).');
};
